module.exports = __webpack_public_path__ + "static/media/FigmaGenerateToken.7e7eca20.png";